import '.ao{position:relative;}.ssr-plugin'
import '.cd{display:inline-flex;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.dv{align-self:flex-start;}.ssr-plugin'
import '.dw{padding:3px;}.ssr-plugin'
import '.dx{background:var(--palette-blue-50);}.ssr-plugin'
import '.dy{border:0.5px solid var(--gray-200);}.ssr-plugin'
import '.cz{border-radius:0.75rem;}.ssr-plugin'
import '.bj{position:absolute;}.ssr-plugin'
import '.dz{top:3px;}.ssr-plugin'
import '.bs{left:0px;}.ssr-plugin'
import '.e0{width:0px;}.ssr-plugin'
import '.e1{height:calc(100% - 6px);}.ssr-plugin'
import '.e2{background:var(--palette-white);}.ssr-plugin'
import '.e3{border:0.5px solid var(--gray-300);}.ssr-plugin'
import '.e4{border-radius:calc(0.75rem - 3px);}.ssr-plugin'
import '.e5{box-shadow:0 1px 3px rgba(0, 0, 0, 0.08);}.ssr-plugin'
import '.cp{pointer-events:none;}.ssr-plugin'
import '.e6{z-index:1;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.aq{justify-content:center;}.ssr-plugin'
import '.e7{gap:0.375rem;}.ssr-plugin'
import '.e8{padding-block:6px;}.ssr-plugin'
import '.e9{padding-inline:18px;}.ssr-plugin'
import '.d3{background:transparent;}.ssr-plugin'
import '.c4{border:none;}.ssr-plugin'
import '.a1{cursor:pointer;}.ssr-plugin'
import '.df{user-select:none;}.ssr-plugin'
import '.ea{white-space:nowrap;}.ssr-plugin'
import '.bd{flex:1;}.ssr-plugin'
import { useCallback, useLayoutEffect, useRef } from 'react'
import { Style, styled } from 'inlines'
import { Text } from '../typography/Text'

export type ToggleOption<T> = {
  label: string
  value: T
  style?: Style
}

export type ToggleProps<T> = {
  options: ToggleOption<T>[]
  selectedOption: T
  setSelectedOption: (option: T) => void
  style?: Style
}

const PILL_TRANSITION =
  'left 0.28s cubic-bezier(0.34, 1.3, 0.64, 1), width 0.28s cubic-bezier(0.34, 1.3, 0.64, 1)'

export const Toggle = <T extends string | boolean>({
  options,
  selectedOption,
  setSelectedOption,
  style,
}: ToggleProps<T>) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const pillRef = useRef<HTMLDivElement>(null)
  const itemRefs = useRef<(HTMLButtonElement | null)[]>([])

  const updatePill = useCallback(() => {
    const selectedIndex = options.findIndex(
      (option) => option.value === selectedOption,
    )
    const activeEl = itemRefs.current[selectedIndex]
    const pill = pillRef.current

    if (!activeEl || !pill) {
      return
    }

    pill.style.left = `${activeEl.offsetLeft}px`
    pill.style.width = `${activeEl.offsetWidth}px`
  }, [options, selectedOption])

  useLayoutEffect(() => {
    const container = containerRef.current
    if (!container) {
      return
    }

    updatePill()

    const observer = new ResizeObserver(() => {
      updatePill()
    })
    observer.observe(container)

    return () => observer.disconnect()
  }, [updatePill])

  return (
    <styled.div className="ao cd t dv dw dx dy cz"
      ref={containerRef}
      style={{
        ...style,
      }}
    >
      <div className="bj dz bs e0 e1 e2 e3 e4 e5 cp"
        ref={pillRef}
        aria-hidden="true"
        style={{
          transition: PILL_TRANSITION,}}
      />
      {options.map((option, index) => {
        const isActive = selectedOption === option.value

        return (
          <styled.button className="ao e6 a t aq e7 e8 e9 d3 c4 e4 a1 df ea bd"
            key={String(option.value)}
            type="button"
            ref={(element) => {
              itemRefs.current[index] = element
            }}
            onClick={() => setSelectedOption(option.value)}
            style={{
              ...(!isActive && {
                '&:hover span': {
                  color: 'var(--brand-secondary)',
                },
              }),
              ...option.style,
            }}
          >
            <Text.Medium
              color={
                isActive
                  ? 'var(--brand-secondary)'
                  : 'var(--palette-blue-400)'
              }
              isBold={isActive}
              style={{ transition: 'color 0.18s' }}
            >
              {option.label}
            </Text.Medium>
          </styled.button>
        )
      })}
    </styled.div>
  )
}
